module.exports = __webpack_public_path__ + "static/media/check-light.c7cd871a.svg";